import types from './types';


export function toggleNavBar() {
    return {
        type: types.TOGGLE_NAVBAR
    }
}
export function hideNavBar() {
    return {
        type: types.HIDE_NAVBAR
    }
}
export function showNavBar() {
    return {
        type: types.SHOW_NAVBAR
    }
}



// WEBPACK FOOTER //
// ./src/js/actions/app.js